// Clone a field and append it to the form provided
export const cloneField = (
  fieldName: string,
  field: HTMLElement,
  form: HTMLFormElement
) => {
  try {
    // Create a new clone
    const cloneId = `_${fieldName}`;
    const clone = field.cloneNode() as HTMLElement;
    // Prepend '_' to ID of clone to allow differentiation between synthetic and real events
    clone.setAttribute('id', cloneId);
    clone.setAttribute('name', cloneId);
    // Ensure the input field is not visible/editable in the UI
    clone.setAttribute('type', 'hidden');
    clone.setAttribute('disabled', 'true');
    clone.setAttribute('style', 'display: none');
    // Ensure no interference occurs with assistive technology and/or accessibility API
    clone.removeAttribute('aria-required');
    clone.setAttribute('aria-hidden', 'true');
    // Remove testing attributes
    clone.removeAttribute('data-testid');
    // Append the element clone to the document
    form.appendChild(clone);
    return clone;
  } catch {
    // To-do
  }
  return null;
};

// Get an existing clone of the given form element
export const getFieldClone = (fieldName: string) => {
  try {
    const cloneId = `_${fieldName}`;
    const clone = document.getElementById(cloneId);
    if (clone) return clone;
  } catch {
    // To-do
  }
  return null;
};

type FormElement = HTMLInputElement | HTMLSelectElement;

const dispatchPrepopChangeEvent = (prepopField: [string, string]) => {
  try {
    const prepopFieldName = prepopField[0];
    const prepopFieldValue = prepopField[1];
    let clone = getFieldClone(prepopFieldName);
    if (!clone) {
      const prepopElement = document.getElementById(prepopFieldName);
      if (!prepopElement) return;
      const { form } = prepopElement as FormElement;
      if (!form) return;
      clone = cloneField(prepopFieldName, prepopElement, form);
      if (!clone) return;
    }
    const syntheticEvent = new Event('change');
    clone.setAttribute('value', prepopFieldValue);
    clone.dispatchEvent(syntheticEvent);
  } catch {
    // To-do
  }
};

// Use synthetic events to track when fields are pre-populated programmatically
export function trackChangeOnPrepop(fields: { [key: string]: string }) {
  const fieldArray = Object.entries(fields);
  fieldArray.forEach((field) => {
    dispatchPrepopChangeEvent(field);
  });
}
